import React, { useEffect, useState } from 'react';
import { useSession } from '../Utils/SessionContext';
import { useNavigate } from 'react-router-dom';
import Navigation from './Components/Navigation';
import Shards from '../PromptComponents/Shards';
import ActionPrompts from '../PromptComponents/ActionPrompts';
import AllPrompts from '../PromptComponents/AllPrompts';

const Prompts = () => {
  const { user } = useSession();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Action Prompts');

  // Set document title
  useEffect(() => {
    document.title = "Prompts";
  }, []);

  // Check if user is Superadmin, redirect if not
  useEffect(() => {
    if (user && user.role !== 'Superadmin') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  // Don't render anything if user is not Superadmin
  if (!user || user.role !== 'Superadmin') {
    return null;
  }

  const tabs = ['Action Prompts', 'All Prompts', 'Shards'];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Action Prompts':
        return <ActionPrompts />;
      case 'All Prompts':
        return <AllPrompts />;
      case 'Shards':
        return <Shards />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-5 pt-[100px]">
      <Navigation title="Prompts" showBackButton={false} />
      
      <div className="w-full mx-auto">
        <div className="bg-white rounded-lg shadow">
          {/* Tab Navigation */}
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </nav>
          </div>
          
          {/* Tab Content */}
          <div className="h-[calc(100vh-200px)]">
            {renderTabContent()}
          </div>
        </div>
      </div>

    </div>
  );
};

export default Prompts;
